<template>
    <div class="login-page">
        <div class="login-area" v-if="!loginSuccess">
            <div class="title">主理人及管理员登录</div>
            <div id="login_container" class="qrcode-area">
                <img v-if="this.code" src="/assets/images/lqr.png" alt="">
            </div>
            <div>
                <span v-if="code">已扫码</span>
                <span v-else>微信扫描二维码登录</span>
            </div>
        </div>
        
        <div v-if="error" class="error">
            <span class="iconfont pc-tishi"></span>
            <span>你的微信暂未绑定任何小程序- {{ error }}<template v-if="loginMemberId">（登录账号ID：{{ loginMemberId }}）</template></span>
        </div>
        <transition name="bounceInDown">
            <div class="confirm-area" v-if="showConfirmArea">
                <div class="ca-progress">
                    <div class="ca-progress-text">开通进度（{{ waiteRegData.finished }}/{{ waiteRegData.total }}）</div>
                    <div class="ca-progress-bar">
                        <div class="ca-progress-bar-item" :style="`width:${progressWidth}`"></div>
                    </div>
                </div>
                <div class="ca-btn btn1" @click="gotoReg"></div>
                <div v-if="showConfirmAreaExitBtn" class="ca-btn btn2" @click="getAppList"></div>
            </div>
        </transition>
        
        <transition name="bounceInDown">
            <div class="apps-area" v-if="showAppsArea">
                
                <div class="area-title">请选择主理人小程序</div>
                <div class="app-list">
                    
                    <div class="apps-container" v-if="!appGroups.length ">
                        
                        <template v-for="app of apps">
                            
                            <div class="app-item" :key="app.id"
                                 :class="{active: app.id === selectedAppId }"
                                 @click=" selectedAppId = app.id "
                            >
                                
                                <template>
                                    <div class="app-avatar">
                                        <div v-if=" app.master_type === 'trusteeship' " class="trusteeship"></div>
                                        <img :src="app.avatar  || '/assets/images/none.png'" alt="">
                                    </div>
                                </template>
                                
                                <div class="app-name">{{ app.nickname || '未设置' }}</div>
                            
                            </div>
                        
                        </template>
                    
                    </div>
                    <div class="apps-container" v-else>
                        
                        <a v-if="appGroupIdx !== 0" @click="appGroupSwitch(-1)" class="app-arrow-left"/>
                        <a v-if="appGroupIdx !== (appGroups.length - 1)" @click="appGroupSwitch(1)"
                           class="app-arrow-right"/>
                        
                        
                        <template v-for="app of appGroups[appGroupIdx]">
                            
                            
                            <div class="app-item" :class="{active: app.id === selectedAppId }" :key="app.id"
                                 @click=" selectedAppId = app.id ">
                                
                                <template>
                                    <div class="app-avatar">
                                        <div v-if=" app.master_type === 'trusteeship' " class="trusteeship"></div>
                                        <div v-if=" !app.register_finished " class="waite-reg-icon"></div>
                                        <img :src="app.avatar || '/assets/images/none.png' " alt="">
                                    </div>
                                </template>
                                
                                <div class="app-name">{{ app.nickname || '未设置' }}</div>
                            
                            </div>
                        
                        
                        </template>
                    
                    </div>
                
                </div>
                <div class="goto-btn" @click="gotoXcx" :class="{active:!!selectedAppId}">进入</div>
            </div>
        </transition>
        
        <div v-if="showExpiredModal" class="expired-modal">
            <div class="renew-tips-body">
                <div class="modal-close" @click="expiredModalClose(false)"></div>
                <div class="renew-tips-header"></div>
                <div class="renew-tips-content">
                    <div class="text-1">续费提醒</div>
                    <div class="text-2">您的系统将在{{  expiredEndDate }}到期</div>
                    <div>
                        <img :src="willExpiredApp.avatar" alt=""/>
                    </div>
                    <div class="text-app-name">{{ willExpiredApp.nickname }}</div>
                    <button class="btn" @click="expiredModalClose(true)">立即续费</button>
                </div>
            </div>
        </div>
    
    </div>
</template>

<script>
import auth from "@/auth";
import api from "../../repo/api";
import moment from "moment";

export default {
    name: "Login",
    data() {
        return {
            state: 'collocation_login',
            showConfirmAreaExitBtn: false,
            showConfirmArea: false,
            waiteRegData: {
                has: false,
                total: 0,
                finished: 0,
            },
            code: 0,
            error: false,
            loginMemberId: '',
            loginSuccess: true,
            showAppsArea: false,
            apps: [],
            appGroups: [],
            appGroupIdx: 0,
            selectedAppId: 0,
            willExpiredApp: null,
            appsNum: 0,
            showExpiredModal: false,
        }
    },
    computed: {
        showMore() {
            return this.showAppsArea && this.appsNum >= 6;
        },
        progressWidth() {
            return (this.waiteRegData.finished / this.waiteRegData.total) * 100 + '%'
        },
        expiredEndDate() {
            return moment(this.willExpiredApp.exp_end_at).format('YYYY年MM月DD日')
        },
    },
    mounted() {
        this.init();
    },
    methods: {
        init() {
            if (this.queryHasCode()) {
                return this.validateCode()
            }
            
            auth.check((success) => {
                
                if (success) return this.loginFinished()
                
                return this.createQRCode();
            })
            
        },
        expiredModalClose(renew) {
            this.showExpiredModal = false
            
            auth.appId(this.willExpiredApp.id)
            
            if (renew) {
                return this.$router.push('/ast/xcx/base?renew=1');
            }
            
            return this.$router.push('/ast/xcx/base');
        },
        queryHasCode() {
            return this.$route.query.code && (this.$route.query.state === this.state);
        },
        validateCode() {
            let code = this.$route.query.code;
            
            this.code = code;
            
            auth.appId(0)
            
            auth.login(code, (success, errorCode) => {
                
                if (success) {
                    return this.loginFinished()
                }
                
                auth.loginOut()
                
                if (errorCode === -100) {
                    this.error = - 100
                }
                
                return this.createQRCode();
            })
        },
        loginFinished() {
            
            this.loginSuccess = true
            
            this.checkPt().then().catch(() => {
                
                if (auth.appId()) {
                    return this.getAppStatus()
                }
                
                this.getAppList()
            })
        },
        getAppStatus() {
            
            api.get('/ast-app/status', (data) => {
                
                if ((!data.data) || (!data.data.status)) {
                    
                    return this.getAppList()
                }
                
                this.selectedAppId = auth.appId()
                
                return this.gotoMainPage(data.data);
            });
        },
        gotoReg() {
            this.showConfirmArea = false;
            auth.appId(0)
            return this.$router.push('/ast/reg');
        },
        checkPt() {
            return new Promise((resolve, reject) => {
                api.get('/ast-reg/waite-reg', (data) => {
                    
                    if (!data.data || !data.data.has) {
                        
                        reject()
                        
                        return
                    }
                    
                    this.waiteRegData = data.data;
                    
                    this.showConfirmArea = true;
                    this.showConfirmAreaExitBtn = data.data.has_app
                })
            })
        },
        gotoMainPage(app) {
            
            console.log(app);
            
            const expEndAt = moment(app.exp_end_at)
            const now = moment(); // 获取当前时间
            
            const daysRemaining = expEndAt.diff(now, 'days', true); // true 表示返回浮点数
            
            if (daysRemaining < 40) {
            // if (daysRemaining > 40) {
                
                this.willExpiredApp = app
                
                this.showExpiredModal = true
                
                return;
            }
            
            auth.appId(app.id)
            
            return this.$router.push('/dashboard');
        },
        getAppList() {
            
            this.showConfirmArea = false;
            
            this.$loading.show()
            
            api.get('/ast-app/apps', (data) => {
                
                this.$loading.hide();
                
                let list = data.data
                
                console.log('获取小程序列表成功');
                
                if (list.length === 1) {
                    
                    return this.gotoMainPage(list[0])
                    
                } else if (list.length === 0) {
                    
                    // auth.loginOut()
                    
                    const loginInfo = auth.userInfo() || {}
                    
                    this.loginMemberId = loginInfo.id || ''
                    
                    this.error = - 200;
                    
                    console.log('app not found.');
                    return
                }
                
                this.apps = JSON.parse(JSON.stringify(list))
                
                this.appsNum = list.length
                
                this.appGroups = [];
                this.appGroupIdx = 0;
                
                if (list.length > 6) {
                    
                    while (list.length > 12) {
                        this.appGroups.push(list.splice(0, 12))
                    }
                    
                    if (list.length) this.appGroups.push(list)
                    
                } else if (list.length > 3) {
                    
                    while (list.length > 3) {
                        this.appGroups.push(list.splice(0, 3))
                    }
                    
                    if (list.length) this.appGroups.push(list)
                }
                
                this.showAppsArea = true
                
            })
            
        },
        gotoXcx() {
            
            if (!this.selectedAppId) return;
            
            let app = this.apps.find((item) => item.id === this.selectedAppId)
            
            if (!app) return;
            
            return this.gotoMainPage(app)
            
        },
        appGroupSwitch(number) {
            this.appGroupIdx += number
        },
        createQRCode() {
            
            this.loginSuccess = false
            
            this.code = 0;
            
            setTimeout(() => {
                /* eslint-disable */
                new WxLogin({
                    self_redirect: false,
                    id: "login_container",
                    appid: "wx7178015fd2dd487c",
                    scope: "snsapi_login",
                    redirect_uri: encodeURI(process.env.VUE_APP_URL + '/login'),
                    state: this.state,
                    href: "https://col.ycsd.work/assets/css/wx.css",
                });
            }, 200)
            
            console.clear()
        }
    }
}
</script>

<style lang="less" scoped>

.login-page, .login-area {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}

.login-page {
    height: 100vh;
    background-image: url("/assets/images/bg-v2.png");
    background-size: cover;
    background-position: center;
    
}

.login-area {
    width: 400px;
    height: 400px;
    background-color: rgba(255, 255, 255, 0.9);
    font-size: 16px;
    line-height: 22px;
    position: relative;
}

.title {
    margin-bottom: 24px;
}

.qrcode-area {
    width: 240px;
    height: 240px;
    border: 1px solid #333333;
    margin-bottom: 32px;
}

#login_container /deep/ iframe {
    width: 100%;
    height: 100%;
}

#login_container img {
    width: 100%;
}

.error {
    position: absolute;
    top: 120px;
    
    padding: 9px 20px;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 21px;
    font-size: 14px;
    font-weight: 400;
    
    display: flex;
    align-items: center;
    
    line-height: 20px;
    
    span {
        color: #FFFFFF;
    }
    
    .iconfont {
        margin-right: 5px;
    }
}

.apps-area {
    width: 400px;
    height: 400px;
    background: rgba(255, 255, 255, 0.9);
    padding: 34px 16px 32px 16px;
    margin-top: 100px;
    user-select: none;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    
    &.show-more {
        width: 800px;
        height: 550px;
        border-radius: 10px;
        margin-top: 0;
        
        .app-list {
            height: auto;
        }
        
        .apps-container, .apps-container > span {
            display: flex;
            width: 100%;
            align-content: center;
            justify-content: space-between;
            align-items: center;
            flex-wrap: wrap;
            flex-direction: row;
        }
    }
    
    .area-title {
        font-size: 16px;
        font-weight: 400;
        color: #333333;
        line-height: 22px;
        text-align: center;
    }
    
    .app-list {
        height: 176px;
        margin-top: 24px;
        padding-left: 22px;
        padding-right: 22px;
        
    }
    
    .goto-btn {
        cursor: pointer;
        margin: 48px auto 0;
        width: 240px;
        height: 40px;
        background: rgba(51, 51, 51, 0.51);
        font-size: 14px;
        font-weight: 400;
        color: #FFFFFF;
        line-height: 40px;
        text-align: center;
        transition: all .3s;
        
        &.active {
            background-color: #333333;
        }
    }
    
    .app-item {
        width: 100px;
        height: 176px;
        margin-right: 12px;
        cursor: pointer;
        position: relative;
        display: flex;
        justify-content: space-around;
        align-items: center;
        flex-direction: column;
        
        &.active, &:active, &:hover {
            .app-avatar {
                border-color: #333333;
            }
            
            .app-name {
                color: #333333;
            }
        }
    }
    
    .app-avatar {
        width: 96px;
        height: 96px;
        border: 1px solid rgba(51, 51, 51, 0.06);
        padding: 8px;
        border-radius: 8px;
        margin-bottom: 8px;
        transition: all .3s;
        
        img {
            width: 80px;
            height: 80px;
            border-radius: 8px;
        }
    }
    
    .app-name {
        height: 40px;
        font-size: 14px;
        font-weight: 400;
        color: rgba(51, 51, 51, 0.4);
        line-height: 20px;
        text-align: center;
        transition: all .3s;
    }
    
    .apps-container, .apps-container > span {
        display: flex;
        width: 324px;
        position: relative;
    }
    
    .app-arrow-left, .app-arrow-right {
        width: 14px;
        height: 14px;
        
        position: absolute;
        top: 50%;
        margin-top: -7px;
        background-size: cover;
    }
    
    .app-arrow-left {
        left: -22px;
        background-image: url("/assets/icons/arrow-left.png");
    }
    
    .app-arrow-right {
        right: -22px;
        background-image: url("/assets/icons/arrow-right.png");
    }
}

.trusteeship {
    width: 32px;
    height: 42px;
    background-image: url("/assets/icons/tg-icon.png");
    background-size: 100%;
    position: absolute;
    left: 0;
    top: 4px;
}

.waite-reg-icon {
    background-image: url("https://static.ycsd.work/collocation-helper/ast/waite-reg-icon.png");
    background-size: contain;
    width: 40px;
    height: 40px;
    position: absolute;
    top: 7px;
    right: 0;
}

.confirm-area {
    width: 1028px;
    height: 548px;
    background-image: url("https://static.ycsd.work/collocation-helper/ast/reg-check-tips-v2.png");
    background-size: cover;
    position: fixed;
    top: 50%;
    left: 50%;
    margin-top: -274px;
    margin-left: -514px;
    box-shadow: 0 0 10px rgba(0, 0, 0, .2);
    
    
    .ca-btn {
        width: 262px;
        height: 65px;
        background-color: transparent;
        position: absolute;
        top: 403px;
        cursor: pointer;
        transition: all .3s;
        
        &:hover {
            background-color: rgba(0, 0, 0, .1);
        }
    }
    
    .btn1 {
        left: 62px;
    }
    
    .btn2 {
        left: 348px;
        background-image: url("https://static.ycsd.work/collocation-helper/ast/reg-check-tips-btn2.png");
        background-size: contain;
        background-blend-mode: overlay;
    }
    
    .ca-progress {
        position: absolute;
        top: 277px;
        left: 62px;
        
        .ca-progress-text {
            font-weight: 400;
            font-size: 20px;
            color: rgba(1, 16, 99, 0.8);
            letter-spacing: 1px;
        }
        
        .ca-progress-bar {
            width: 360px;
            height: 16px;
            background: #FFFFFF;
            border-radius: 44px;
            margin-top: 12px;
            position: relative;
            overflow: hidden;
        }
        
        .ca-progress-bar-item {
            width: 100%;
            height: 100%;
            background: linear-gradient(90deg, #7891F2 0%, #3842E3 100%);
            border-radius: 44px;
        }
    }
}

.expired-modal {
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    background-color: rgba(51, 51, 51, 0.51);
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.renew-tips-body {
    width: 360px;
    position: relative;
    
    .modal-close {
        width: 16px;
        height: 16px;
        position: absolute;
        top: 56px;
        right: 16px;
        background-image: url("/assets/icons/modal-close.png");
        cursor: pointer;
        background-size: cover;
    }
}

.renew-tips-header {
    height: 130px;
    background-image: url("/assets/images/col-renew-tips.png");
    background-size: 100%;
}

.renew-tips-content {
    
    background-color: white;
    padding-top: 16px;
    margin-top: -8px;
    padding-bottom: 20px;
    
    .text-1 {
        font-weight: 500;
        font-size: 20px;
        color: #333333;
        margin-top: 10px;
    }
    
    .text-2 {
        font-weight: 500;
        font-size: 16px;
        color: #333333;
        margin-top: 16px;
    }
    
    img {
        width: 48px;
        height: 48px;
        border-radius: 50%;
        margin-top: 8px;
    }
    
    .text-app-name {
        font-weight: 400;
        font-size: 14px;
        color: #333333;
        margin-top: 8px;
    }
    
    .btn {
        margin-top: 32px;
        border-radius: 37px;
        width: 120px;
        height: 40px;
    }
}

</style>